import _get from 'lodash/get';
import { Google, Pixall } from '../analytics/index.js';
import { addListingTriggerData, getInventoryOwnerById, isPremiumSpotlight } from '../utilities/index.js';

/**
 * @summary Sends Google event for Report Listing SRP click
 */
export async function reportListingClick(_ref, option) {
  let {
    data = {},
    dataLayer,
    state
  } = _ref;
  const inventory = getInventoryOwnerById(state, data?.inventoryId);
  const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
  const {
    par
  } = data;
  const listingType = isPremiumSpotlight(par) ? 'highlight' : undefined;
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventResult: 'text-link::report-this-listing-to-autotrader'
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    eventType: 'click',
    cdl: addListingTriggerData(par),
    label: `rpt_lstg_${dataLayer?.brand}`,
    listingType,
    inventory,
    pageId,
    pixallData: {
      ...data?.pixallData
    },
    par: data?.par
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Google event for send Report
 */
export async function sendReportClick(_ref2, option) {
  let {
    data = {},
    dataLayer,
    state
  } = _ref2;
  const inventory = getInventoryOwnerById(state, data?.inventoryId);
  const pageId = _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '');
  const par = data?.par;
  const listingType = isPremiumSpotlight(par) ? 'highlight' : undefined;
  Google.sendClickEvent({
    eventElement: 'dealer',
    eventResult: `cta::send-report::${data?.reason}`
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    eventType: 'click',
    label: `snd_report-${data?.reason}`,
    listingType,
    inventory,
    pageId,
    par,
    pixallData: {
      ...data?.pixallData
    },
    cdl: addListingTriggerData(par)
  }, dataLayer, option);
  return {};
}
export default {
  reportListingClick,
  sendReportClick
};